import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const CLASSES = [{
  icon: '🤖',
  title: 'Visual AI con Google Gemini',
  desc: 'Aprendé a usar Gemini para generar ideas y contenido con IA.'
}, {
  icon: '🧠',
  title: 'Cómo aterrizar tu conocimiento con IA',
  desc: 'Transformá ideas en contenido o proyectos.'
}, {
  icon: '🎨',
  title: 'Visual AI con Midjourney',
  desc: 'Creá imágenes impresionantes con inteligencia artificial.'
}, {
  icon: '🎙',
  title: 'Crear voces ilimitadas con IA',
  desc: 'Generá narraciones y locuciones automáticas.'
}, {
  icon: '🎧',
  title: 'Mejorar calidad de audio con IA',
  desc: 'Herramientas que limpian y mejoran audio automáticamente.'
}, {
  icon: '🎬',
  title: 'Crear videos desde una fotografía',
  desc: 'Convertí imágenes en videos realistas.'
}, {
  icon: '🎭',
  title: 'Crear escenas con los mismos personajes',
  desc: ''
}, {
  icon: '🖼',
  title: 'Gemini y la nueva creación de imágenes',
  desc: ''
}, {
  icon: '💰',
  title: 'IA gratuita vs IA de pago',
  desc: ''
}, {
  icon: '🎨',
  title: 'Creación profesional de imágenes con IA',
  desc: ''
}, {
  icon: '🧑‍💻',
  title: 'Avatares y narración con inteligencia artificial',
  desc: ''
}, {
  icon: '🧠',
  title: 'Cómo tener un mentor con IA gratis',
  desc: ''
}, {
  icon: '🎥',
  title: 'Creación de videos completos con IA',
  desc: ''
}];
export function CurriculumSection() {
  return <section className="bg-[#0a0a0a] py-24 px-4 border-t-4 border-[#a855f7]" data-id="element-19">
      <div className="max-w-5xl mx-auto" data-id="element-20">
        <div className="text-center mb-16" data-id="element-21">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6" data-id="element-22">
            📚 Lo que vas a aprender dentro del curso
          </h2>
          <p className="text-xl md:text-2xl text-[#FFD700] font-bold" data-id="element-23">
            Este entrenamiento incluye clases en video prácticas donde vas a
            descubrir:
          </p>
        </div>

        <a href="#comprar" className="block mb-16 cursor-pointer group" data-id="element-24">
          <div className="relative rounded-2xl overflow-hidden shadow-[0_0_40px_rgba(168,85,247,0.2)] border border-white/10 transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-25">
            <img src="https://cdn.magicpatterns.com/uploads/7vywDvQfcEnYbTv8GbcYVN/hf_20260315_025623_2a68f699-45e7-473c-8913-ad3cadbc4b4a.jpg" alt="Contenido del curso" className="w-full h-auto object-cover" width={1200} height={675} loading="lazy" decoding="async" data-id="element-26" />
          </div>
        </a>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.4
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-27">
          {CLASSES.map((cls, idx) => <div key={idx} className="bg-[#111] border border-white/10 rounded-xl p-6 hover:border-[#a855f7]/50 transition-colors flex gap-4 items-start" data-id="element-28">
              <div className="text-3xl bg-[#1a0533] p-3 rounded-lg border border-[#a855f7]/30" data-id="element-29">
                {cls.icon}
              </div>
              <div data-id="element-30">
                <h4 className="text-lg font-bold text-white mb-1" data-id="element-31">
                  {cls.title}
                </h4>
                {cls.desc && <p className="text-[#c4b5d4] text-sm" data-id="element-32">{cls.desc}</p>}
              </div>
            </div>)}
        </motion.div>

        <div className="text-center" data-id="element-33">
          <CTAButton data-id="element-34">🚀 ¡QUIERO ACCEDER A TODAS LAS CLASES!</CTAButton>
        </div>
      </div>
    </section>;
}